import { render } from "./InputCheckboxBoolean.vue?vue&type=template&id=20de7d85&scoped=true&ts=true"
import script from "./InputCheckboxBoolean.vue?vue&type=script&lang=ts"
export * from "./InputCheckboxBoolean.vue?vue&type=script&lang=ts"

import "./InputCheckboxBoolean.vue?vue&type=style&index=0&id=20de7d85&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20de7d85"]])

export default __exports__